enum Gender {
  MALE,
  FEMALE,
  OTHER,
  DO_NOT_WISH_TO_DISCLOSE,
}

export default Gender;



// WEBPACK FOOTER //
// ./src/models/gender.ts